import { ViewContainerRef } from "@angular/core";
import { IEvrideoDialogService } from "app/js/src/domain/common/i-evrideo-dialog-service";
import { ContentControlStudioKeyboardShortcuts } from "app/js/src/domain/common/keyboard-shortcuts";
import { IContentControlManager } from 'app/js/src/domain/content-control/manager';
import { IContentControlVideoSource } from 'app/js/src/domain/content-control/i-content-control-video-source';
import {
  IContentControlStudioViewModel,
  IStudioKeyboardActions,
} from 'app/js/src/domain/content-control/studio';
import { EvrideoKeyboardShortcutsComponent } from "../../../common/evrideo-keyboard-shortcuts/evrideo-keyboard-shortcuts.component";

export class StudioKeyboardActions implements IStudioKeyboardActions {
  constructor(
    private readonly _getVideo: () => IContentControlVideoSource | undefined,
    private readonly _manager: IContentControlManager,
    private readonly _dialogService: IEvrideoDialogService,
    private readonly _viewContainerRef: ViewContainerRef,
    private readonly _vm: IContentControlStudioViewModel,
  ) {}

  isVideoPaused(): boolean {
    return this._getVideo()?.paused ?? true;
  }

  play(): void {
    this._vm.play();
  }

  pause(): void {
    this._vm.pause();
  }

  undo(): void {
    this._manager.undoOperation();
  }

  redo(): void {
    this._manager.redoOperation();
  }

  save(): void {
    this._vm.save();
  }

  openKeyboardShortcutsDialog(): void {
    this._vm.isFragmentDialogOpen = true;
    this._dialogService
      .openDialog(this._viewContainerRef, {
        type: "simple",
        title: "Keyboard Shortcuts",
        content: EvrideoKeyboardShortcutsComponent,
        contentContext: {
          shortcuts: ContentControlStudioKeyboardShortcuts,
        },
        timeout: -1,
      })
      .finally(() => {
        this._vm.isFragmentDialogOpen = false;
      });
  }

  changePlaybackSpeed(delta: number): void {
    this._vm.changePlaybackSpeed(delta);
  }

  frameUp(multiply?: number): void {
    this._vm.frameUp(multiply);
  }

  frameDown(multiply?: number): void {
    this._vm.frameDown(multiply);
  }

  timelineZoom(direction: number): void {
    this._vm.timelineZoom(direction);
  }

  timelineZoomFitVideo(): void {
    this._vm.timelineZoomFitVideo();
  }

  timelineZoomFitSegment(): void {
    this._vm.timelineZoomFitSegment();
  }

  goToIn(): void {
    this._vm.goToIn();
  }

  goToOut(): void {
    this._vm.goToOut();
  }

  changeSelectedSegment(id: number): void {
    this._vm.changeSelectedSegment(id);
  }

  chooseWhatToDelete(): void {
    this._vm.chooseWhatToDelete();
  }

  toggleMuteKey(): void {
    this._vm.toggleMuteKey();
  }

  markIn(): void {
    this._vm.markIn();
  }

  markOut(): void {
    this._vm.markOut();
  }
}
